export default "__VITE_ASSET__365w6qOI__"